import React from 'react';
import { useTranslations } from '../hooks/useTranslations';
export function LiveLabel() {
    const { t } = useTranslations();
    return React.createElement("label", { className: "WhSearch-LiveLabel" }, t('live'));
}
//# sourceMappingURL=LiveLabel.js.map